// ═══════════════════════════════════════════════════════════════════
//  composants/DataTable.js
//  DataTable
// ═══════════════════════════════════════════════════════════════════

import { useIsMobile } from "../socle/hooks";
import { THEME } from "../socle/theme";
import { cardBox, cardLabel, iconBtn } from "./styles";

// ═══════════════ Générique : tableau + formulaire ═══════════════
export function DataTable({ columns, rows, onEdit, onDelete, empty }) {
  const isMobile = useIsMobile();
  const grid = columns.map((c)=>c.width||"1fr").join(" ") + (onEdit||onDelete ? " 80px" : "");
  if (isMobile) {
    if (rows.length===0) return <div style={{padding:16,color:THEME.textMuted,fontSize:13}}>{empty||"Aucune entrée."}</div>;
    return (
      <div>
        {rows.map((row)=>(
          <div key={row.id} style={cardBox}>
            {columns.map((c)=>(
              <div key={c.key} style={{display:"flex",justifyContent:"space-between",alignItems:"center",gap:10,padding:"3px 0",fontSize:13}}>
                <span style={cardLabel}>{c.label}</span>
                <span style={{color:THEME.text,textAlign:"right",overflow:"hidden",textOverflow:"ellipsis"}}>{c.render?c.render(row):(row[c.key]??"—")}</span>
              </div>
            ))}
            {(onEdit||onDelete)&&(
              <div style={{display:"flex",gap:6,justifyContent:"flex-end",marginTop:8,borderTop:`1px solid ${THEME.border}`,paddingTop:8}}>
                {onEdit&&<button onClick={()=>onEdit(row)} title="Éditer" style={iconBtn}>✏️</button>}
                {onDelete&&<button onClick={()=>onDelete(row.id)} title="Supprimer" style={iconBtn}>🗑️</button>}
              </div>
            )}
          </div>
        ))}
      </div>
    );
  }
  return (
    <div style={{background:THEME.panel,border:`1px solid ${THEME.border}`,borderRadius:14,overflow:"hidden"}}>
      <div style={{display:"grid",gridTemplateColumns:grid,padding:"10px 14px",borderBottom:`1px solid ${THEME.border}`,color:THEME.textMuted,fontSize:11,fontWeight:700,textTransform:"uppercase"}}>
        {columns.map((c)=><div key={c.key} style={{textAlign:c.align||"left"}}>{c.label}</div>)}
        {(onEdit||onDelete)&&<div></div>}
      </div>
      {rows.length===0 && <div style={{padding:20,color:THEME.textMuted,fontSize:13}}>{empty||"Aucune entrée."}</div>}
      {rows.map((row)=>(
        <div key={row.id} style={{display:"grid",gridTemplateColumns:grid,padding:"10px 14px",borderBottom:`1px solid ${THEME.border}`,alignItems:"center",fontSize:13}}>
          {columns.map((c)=><div key={c.key} style={{textAlign:c.align||"left",color:THEME.text,overflow:"hidden",textOverflow:"ellipsis"}}>{c.render?c.render(row):(row[c.key]??"—")}</div>)}
          {(onEdit||onDelete)&&(
            <div style={{textAlign:"right",display:"flex",gap:6,justifyContent:"flex-end"}}>
              {onEdit&&<button onClick={()=>onEdit(row)} title="Éditer" style={iconBtn}>✏️</button>}
              {onDelete&&<button onClick={()=>onDelete(row.id)} title="Supprimer" style={iconBtn}>🗑️</button>}
            </div>
          )}
        </div>
      ))}
    </div>
  );
}
